"use strict";
const _ = require('lodash');
_.mixin(require('lodash-uuid'));
const { alcoholTaxCalculator, } = require('../../models/article/alcohol-tax-calculator');
const { alcTaxArticle } = require('../../models/article');
const rowIsAlcTaxCancellingRow = orderRow => _.get(orderRow, 'article.articleNumber') === alcTaxArticle.articleNumber;
const filterOutAlcTaxCancellingRows = orderRows => orderRows.filter(x => !rowIsAlcTaxCancellingRow(x));
const getAlcTaxCancellingRows = orderRows => orderRows.filter(x => rowIsAlcTaxCancellingRow(x));
const totalAlcTax = ({ orderRows }) => _.sumBy(orderRows, x => x.article ? alcoholTaxCalculator(x.article) * x.deliveredQuantity : 0);
const createAlcTaxCancellingRows = orderRows => {
    const alcoholTax = totalAlcTax({ orderRows });
    return [
        {
            id: _.uuid(),
            name: alcTaxArticle.name,
            price: -alcoholTax,
            unit: 'single',
            deliveredQuantity: 1,
            orderedQuantity: 1,
            article: alcTaxArticle,
            total: -alcoholTax,
            lookups: {
                article: { articleNumber: alcTaxArticle.articleNumber },
            },
        },
    ];
};
module.exports = {
    filterOutAlcTaxCancellingRows,
    getAlcTaxCancellingRows,
    createAlcTaxCancellingRows,
    totalAlcTax,
};
